var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNose1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46.7 39.8",
    style: {
      enableBackground: "new 0 0 46.7 39.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.6;fill:#D177B8;enable-background:new    ;}\n\t.st2{opacity:0.6;fill:url(#SVGID_00000041259819232838235820000015274022050256940478_);enable-background:new    ;}\n\t.st3{fill:url(#SVGID_00000127761889369896922630000016659083137980860034_);}\n\t.st4{fill:url(#SVGID_00000018933761644128994650000017609434423100240512_);}\n\t.st5{opacity:0.25;fill:url(#SVGID_00000013168223701446017220000017205609792239441551_);enable-background:new    ;}\n\t.st6{opacity:0.6;fill:url(#SVGID_00000019673204218530526810000010587024668999050639_);enable-background:new    ;}\n\t.st7{opacity:0.6;fill:url(#SVGID_00000008867815189133870510000016566414478828477084_);enable-background:new    ;}\n\t.st8{fill:#FFCCB8;}\n\t.st9{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.3,
    y1: -71.3496,
    x2: 23.3,
    y2: 230.2783,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2552,
    style: {
      stopColor: "#FF9673"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3026,
    style: {
      stopColor: "#FA9F82",
      stopOpacity: 0.7247
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3723,
    style: {
      stopColor: "#F4A992",
      stopOpacity: 0.3198
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4273,
    style: {
      stopColor: "#F2AD97",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.6,11.9c0,0-11.5-11.3-19.4-11.9c-0.2,0-1.7,0-1.9,0C14.6,0.5,3,11.9,3,11.9s-5.6,9.4-1.5,13.4 c4.1,3.9,14.6,6.1,14.6,6.1s4.1,2.1,7.4,2.1s7-2.1,7-2.1s10.5-2.2,14.6-6.1C49.2,21.3,43.6,11.9,43.6,11.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.1,25.2c-4.1,3.9-14.6,6.1-14.6,6.1s-3.8,2.1-7,2.1c-3.3,0-7.4-2.1-7.4-2.1S5.6,29.1,1.5,25.2 c-1.4-1.3-1.7-3.3-1.4-5.3c1.8,2.8,3.5,3.6,10.9,3.6c1.1,0,1.8,3.2,4.6,4.8c2.5,1.5,6,1.5,7.7,1.6c1.7,0,5.1-0.1,7.7-1.6 c2.8-1.6,3.5-4.8,4.6-4.8c7.5,0,9.1-0.9,11-3.7C46.8,21.9,46.5,23.9,45.1,25.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153673799846543357440000004768584349032512171_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.4174,
    y1: 23.121,
    x2: 22.9524,
    y2: -10.0128,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000153673799846543357440000004768584349032512171_)",
      enableBackground: "new"
    },
    d: " M23.5,39.8c-10.5,0-22.2-14.2-22.6-15c-2.6-5.1,1.2-11.3,2.1-13C1.2,17.6,1.9,22,2.4,22.2c1.6,0.9,4,1.3,8.6,1.3 c1.1,0,1.8,3.2,4.6,4.8c2.5,1.5,6,1.5,7.7,1.6c1.7,0,5.1-0.1,7.7-1.6c2.8-1.6,3.5-4.8,4.6-4.8c5.4,0,7.7-0.4,9.3-1.7 c1-0.8,0.6-6.1-1.2-9.9c1.3,2.3,4.4,8.8,2.3,12.2C41,32.4,32.5,39.8,23.5,39.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097489504637639566170000011190974688293965990_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.2918,
    y1: 11.602,
    x2: 15.605,
    y2: 11.602,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097489504637639566170000011190974688293965990_)"
    },
    d: "M15.6,31.2c-1.5-0.3-6-1.4-9.7-3.2 c-0.7-0.3-3.1-2.9,0-2.6C9.4,25.8,13.8,29.9,15.6,31.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084517763268652525230000002819494394783466625_",
    gradientUnits: "userSpaceOnUse",
    x1: -5803.0493,
    y1: 11.602,
    x2: -5791.7358,
    y2: 11.602,
    gradientTransform: "matrix(-1 0 0 -1 -5760.6851 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084517763268652525230000002819494394783466625_)"
    },
    d: "M31.1,31.2c1.5-0.3,6-1.4,9.7-3.2 c0.7-0.3,3.1-2.9,0-2.6C37.2,25.8,32.8,29.9,31.1,31.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103974489968153209830000011533484682075153033_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.461,
    y1: 20.3324,
    x2: 34.146,
    y2: 20.3324,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000103974489968153209830000011533484682075153033_)",
      enableBackground: "new"
    },
    d: " M22,10.1c-4.7,0.4-9.9,13.3-9.6,14.3c0.3,1,5.9,4.2,10.9,4.6c3.9,0.4,10.6-4.3,10.8-5C34.5,23,26.8,9.7,22,10.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022546690320509148970000002566674742523391668_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.5812,
    y1: 29.5975,
    x2: 9.7095,
    y2: 0.3829,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000022546690320509148970000002566674742523391668_)",
      enableBackground: "new"
    },
    d: " M14.8,11.9c-0.8,5.7-3,12.2-3,12.2s-0.3-0.5-0.6-0.6c-0.2,0-1.2,0-2.2,0c-0.9,0-1.7-0.1-1.7-0.1s8.9-5.5,7.6-20.6 C15.1,4.6,15.4,8.1,14.8,11.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093150591125101730390000018307962460140232104_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.485,
    y1: 28.117,
    x2: 33.6147,
    y2: -1.0758,
    gradientTransform: "matrix(1 0 0 -1 0 39.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000093150591125101730390000018307962460140232104_)",
      enableBackground: "new"
    },
    d: " M31.7,11.9c0.8,5.7,3,12.2,3,12.2s0.3-0.5,0.6-0.6c0.2,0,1.2,0,2.2,0c0.9,0,1.7-0.1,1.7-0.1S31,16.7,31.6,2.8 C31.5,4.6,31.2,8.1,31.7,11.9z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M13.4,24.2c0,0,4.9,2.6,7.7,2.7s11.9-2.3,11.8-2.3S13.4,24.2,13.4,24.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M17.3,23.9c0,0.4,1.4,2.8,1.4,2.8l4.4-0.3c0,0,1.8-1.9,1.3-1.9C23.9,24.4,17.3,23.9,17.3,23.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNose1);
export default __webpack_public_path__ + "static/media/Nose1.99f84d61f15f38a5838109777901e69e.svg";
export { ForwardRef as ReactComponent };